import { RegionShortcut } from 'components/region/RegionShortcut';
import React from 'react';
import classNames from 'classnames';

import type { IRelatedForResort } from 'api/region/types';

import { RelatedHeader } from 'components/common/TabsNavigationRedesign/components/RelatedHeader';

import styles from './styles.module.scss';

interface IProps {
  className?: string,
  regionName: string,
  related: IRelatedForResort | undefined,
}

export const RegionRelatedDataHeader = ({
  regionName,
  className,
  related,
}: IProps) => (
  <div className={classNames(styles.wrapper, className)}>
    <RegionShortcut
      regionName={regionName}
    />
    <RelatedHeader related={related} />
  </div>
);
